import { edmCampaign } from '@bingads-webui/edm-campaign';

export const createOrUpdateCampaign = (data) => {
  const campaignEDM = edmCampaign.types.resolve('Model.ShoppingCampaign');
  const campaignResource = new campaignEDM.ResourceIdentifier();
  const createOrUpdateCall = data && data.Id ?
    campaignResource.bulkUpdate.bind(campaignResource) :
    campaignResource.bulkCreate.bind(campaignResource);
  return createOrUpdateCall(data);
};

export const deleteCampaign = (id) => {
  const campaignEDM = edmCampaign.types.resolve('Model.ShoppingCampaign');
  const campaignResource = new campaignEDM.ResourceIdentifier();
  const deleteCall = campaignResource.bulkDestroy.bind(campaignResource);
  return deleteCall(id);
};

export const readCampaign = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .get({
      select: ['Budget', 'CampaignConversionGoal/Goals'],
    })
    .toPromise();

// Read campaigns with PerformanceMax campaign type
export const readCampaigns = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns
    .get({
      filter: {
        where: 'CampaignType eq \'PerformanceMax\'',
      },
    })
    .toPromise();

const campaignCriterionTypeName = 'Model.CampaignCriterion';

export const readCampaignCriterions = (cid, aid, campaignId, type) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .CampaignCriterions
    .$cast(campaignCriterionTypeName)
    .get({
      filter: {
        where: type,
      },
    })
    .toPromise();

export const readLocationCriterions = (cid, aid, campaignId) =>
  readCampaignCriterions(
    cid, aid, campaignId,
    "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')"
  );

export const readDayTimeCriterions = (cid, aid, campaignId) =>
  readCampaignCriterions(
    cid, aid, campaignId,
    "isof(Criterion,'Model.DayTimeCriterion')"
  );

export const createOrUpdateAssetGroup = (data) => {
  const assetGroupEDM = edmCampaign.types.resolve('Model.AssetGroup');
  const assetGroupResource = new assetGroupEDM.ResourceIdentifier();
  const createOrUpdateCall = data && data.Id ?
    assetGroupResource.bulkUpdate.bind(assetGroupResource) :
    assetGroupResource.bulkCreate.bind(assetGroupResource);
  return createOrUpdateCall(data);
};

export const createOrUpdateListingGroup = (itemsToAdd, itemsToDelete) => {
  const listingGroupEDM = edmCampaign.types.resolve('Model.ProductListingGroup');
  const listingGroupResource = new listingGroupEDM.ResourceIdentifier();
  const data = itemsToDelete.concat(itemsToAdd);
  const createOrUpdateCall = data && data.Id ?
    listingGroupResource.bulkUpdate.bind(listingGroupResource) :
    listingGroupResource.bulkCreate.bind(listingGroupResource);
  return createOrUpdateCall(data);
};

export const readAssetGroup = (cid, aid, campaignId, assetGroupId, isSearchThemeEnabled, isUrlRulesEnabled = false) => {
  const toSelect = ['Headlines', 'LongHeadlines', 'Descriptions', 'AudienceGroup', 'Images', 'Videos'];

  if (isSearchThemeEnabled) toSelect.push('AssetGroupSearchThemes');
  if (isUrlRulesEnabled) toSelect.push('AssetGroupUrlTargets');

  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AssetGroups.$withKey(assetGroupId)
    .get({ select: toSelect })
    .toPromise();
};

export const readCampaignNegativeWebpages = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .CampaignNegativeWebpages
    .get({
      top: 10000,
      skip: 0,
    })
    .toPromise();

export const readConversionGoalDetails = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)['Default.ConversionGoalDetails']
    .$makeCall()
    .toPromise();

export const readExtensionAssociations = (cid, aid, campaignId, payload, top = 20) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdExtensionAssociations['Default.GridData']
    .$makeCall({
      query: {
        top,
        filter: { where: "(AdExtension/Status eq Enum.AdExtensionStatus'Active')" },
        select: ['AdExtension'],
      },
      payload,
    })
    .toPromise();

export const readNewCustomerAcquisitionGoals = (cid, aid) => {
  const edm = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .NewCustomerAcquisitionGoals;

  return edm.get().toPromise();
};
